<template>
  <div :class="$style.container">
    <div :class="$style.content">
      <div :class="$style.company">
        <div :class="$style.company_logo">
          <img :class="$style.company_logo_img" :src="companyLogo"/>

        </div>
        <div :class="$style.company_name">{{ companyName }}</div>
      </div>
      <div :class="$style.company_name_icon">
        <el-tooltip placement="bottom-start" :popper-class="$style.popper_class_tooltip" v-if="levelPic" :visible-arrow="false" effect="light">
          <div slot="content">
            <div class="mb-1"><span :class="$style.title">黑标：</span>精选邮轮市场畅销产品，一手库存、价格，快速成交，提供有竞争力的佣金，获得更高的回报。</div>
            <div class="mb-1"><span :class="$style.title">金标：</span>覆盖市场大部分需求，实时更新库存，让您时刻了解产品的可售性，保障业务稳定发展。</div>
            <div class="mb-1"><span :class="$style.title">银标：</span>覆盖全球市场多个领域，确保满足不同客户的需求，推动您的业务多元化的发展。</div>
          </div>
          <div :class="$style.label_icon">
            <el-image fit="cover" :class="$style.label_icon" :src="levelPic"></el-image>
          </div>
        </el-tooltip>
        <h1 :class="[$style.name, {[$style.company_has_icon]: levelPic}]">{{ title }}</h1>
      </div>
      <ul class="flex flex-wrap mt-2.5 h-6 overflow-hidden">
        <li
            class="inline-flex items-center px-1 rounded-sm text-xxs mr-2 mb-2 h-5"
            v-for="(item, index) in tags"
            :key="index"
            :class="[ index === 0 ? {
                'bg-orange text-white': Number(cruiseProductType) === 2,
                'bg-purple text-white': Number(cruiseProductType) === 1
            } : 'border border-[#7378E6] text-[#7378E6]']"
        >{{ item }}
        </li>
      </ul>
      <ul :class="$style.attrs">
        <li :class="$style.attr"><i class="ficon ficon-ziyuancaigou_chufa"/><span :class="$style.attr_value">出发：{{
            departure
          }}</span></li>
        <li :class="$style.attr"><i class="ficon ficon-ziyuancaigou_daoda"/><span :class="$style.attr_value">到达：{{
            destination
          }}</span></li>
        <li :class="$style.attr"><i class="ficon ficon-ziyuancaigou_gangkou"/><span
            :class="$style.attr_value">停靠：{{ ports.join('、') }}</span></li>
        <li :class="$style.attr"><i class="ficon ficon-id"/><span :class="$style.attr_value">产品编号：{{
            productNo
          }}</span>
          <button class="transition-colors hover:text-highlight" type="button"
                  @click="copy(productNo)"><i class="ficon ficon-fuzhi"/></button>
        </li>
      </ul>
      <productDetailJoinStore v-if="productNo" :title="title" :is-favorite="isFavorite" :is-in-shop="isInShop"
                              :is-open-shop="isOpenShop" :status="status" @join="$emit('join')" @share="$emit('share')"
                              @favorite="$emit('favorite')"/>
    </div>
  </div>
</template>
<script>
import {defineComponent,ref} from "@nuxtjs/composition-api";
import {useClipboard, whenever} from "@vueuse/core";
import ProductAttrs from "~/components/automation/product-attrs.vue";
import useMessage from "~/composables/useMessage";

import productDetailJoinStore from "./product-detail-join-store.vue";


export default defineComponent({
  components: {
    ProductAttrs,
    productDetailJoinStore
  },
  props: {
    title: String,
    productNo: String,
    departure: String,
    departureDate: String,
    destination: String,
    destinationDate: String,
    isFavorite: Boolean,
    isInShop: Boolean,
    isOpenShop: Boolean,
    status: [Number, String],
    cruiseProductType: [String, Number],
    tags: Array,
    ports: {
      /** @type { import('vue').PropType<string[]> } */
      type: Array,
      default: () => []
    },
    minSalePrice: [String, Number],
    minThPrice: [String, Number],

    companyName: String,
    companyLogo: String,
    levelPic: String,
    cruiseInfo: {
      type: Object,
      default: () => ({
        id: "",
        title: "",
        title_en: "",
        images: [],
        type: "",
        type_label: "",
        cover: "",
        tonnage: "",
        passenger: "",
        first_time: "",
        renovation_time: "",
        floor: "",
        length: "",
        width: "",
        speed: "",
        intro: "",
        describe: ""
      })
    }
  },
  emits: ['share', 'favorite', 'join'],
  setup() {
    const {copy, copied} = useClipboard();
    const message = useMessage();
    whenever(copied, () => {
      message.success('复制成功')
    })
    return {
      copy
    }
  },
  computed: {
    isDistributor() {
      if (!this.$store.getters.loggedIn) {
        return false;
      }
      // if (!this.auth.loggedIn) return false;
      return !!this.$store.getters.userInfo.distributor;
    }
  }
});
</script>
<style lang="scss" module>
.container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}
.content {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
}
.aside {
  margin-left: 1.75rem;
  position: relative;
}
.name {
  font-weight: 500;
  font-size: 1.625rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.price {
  margin-top: 1.25rem;
}
.cover {
  border-radius: 0.5rem;
  overflow: hidden;
  position: relative;
  width: 19.25rem;
}
.cover_img {
  display: block;
  height: 14.5rem;
  width: 19.25rem;
}
.company {
  border-radius: 0.25rem;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.company_logo {
  --tw-border-opacity: 1;
  border-color: rgba(151, 154, 168, var(--tw-border-opacity));
  border-radius: 0.25rem;
  border-width: 1px;
  height: 2.25rem;
  -o-object-fit: cover;
  object-fit: cover;
  position: relative;
  width: 6.75rem;
  z-index: 1;
}
.company_logo_img {
  border-radius: 0.25rem;
  height: 100%;
  width: 100%;
}
.company_name {
  border-radius: 0.25rem;
  font-weight: 500;
  font-size: 1.125rem;
  line-height: 1.75rem;
  line-height: 2.25rem;
  margin-left: -0.75rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-left: 1.75rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  background: linear-gradient(270deg, rgba(#F2007D, .4) 0%, rgba(#F2B203, .4) 100%);
}
.company_name_icon {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  margin-top: 0.875rem;
  position: relative;
}
.company_has_icon {
  text-indent: 32px;
  margin-left: -30px;
}
.label_icon {
  height: 34px;
  width: 34px;
  margin-top: 1px;
}
.popper_class_tooltip {
  border: 1px solid #D4D7DE !important;
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1) !important;
  width: 248px !important;
  color: #1F2129;
  padding: 8px 10px 6px;
  margin-top: 2px !important;
  text-align: justify;
}
.title {
  font-weight: 500;
}
.attrs {
  margin-top: 0.5rem;
}
.attr {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  margin-top: 0.375rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.attr_value {
  margin-left: 0.5rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.cruise {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: end;
  -ms-flex-align: end;
  -webkit-align-items: flex-end;
  align-items: flex-end;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  padding: 1rem;
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 0px;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  background: linear-gradient(360deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
}
.cruise-attrs {
  font-size: 0.8125rem;
  line-height: 1.125rem;
}
.cruise-attr {
  margin-top: 0.25rem;
}
.cruise_name {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
</style>
